export default __webpack_public_path__ + "static/media/img-specific-verticals.c9ca5729.png";